import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-general-detail-container',
  templateUrl: './general-detail-container.component.html',
  styleUrls: ['./general-detail-container.component.scss']
})
export class GeneralDetailContainerComponent implements OnInit {
  tournamentFormGeneral: FormGroup;
  public isLoading: boolean = false;
  public imageUrl: string | ArrayBuffer | null = null;
  uploadedImage: File;
  public imageSignedURL = '';
  public tournamentID = '';
  public s3UploadedImage = '';
  public tournamentFetchedDetails: any = '';



  constructor(
    private fb: FormBuilder,
    private localInterfaceSrv: LocalInterfaceService,
    private toastr: ToastrService,
    private validationSrv: ValidationService,
    public router: Router,
    public route: ActivatedRoute

  ) { }





  ngOnInit(): void {
    this.validationSrv.validateAcess()
      .then(async () => {
        // this.isLoading = true;
        const tournamentID = this.route.snapshot.params['id'];
        this.tournamentID = tournamentID
        console.log('tournamentID:', tournamentID);
        await this.loadTournamentDetails(tournamentID)

        this.createForm();


      });

  }

  loadTournamentDetails = async (tournamentID) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .getTournamentDetails(tournamentID)
        .then(async (res) => {
          this.isLoading = false;
          console.log('res----', res);
          this.tournamentFetchedDetails = res?.data?.content
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err.description, 'Error');
        })
        .finally(() => {
          this.isLoading = false;
        });
    });

  }

  onFileSelected = async (event: any) => {
    const file: File = event.target.files[0];
    await this.getSignedURLForImage(file);
    if (file) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  createForm(): void {
    this.imageUrl = this.tournamentFetchedDetails.tournamentLogo
    this.tournamentFormGeneral = this.fb.group({
      // id: [this.tournamentFetchedDetails.id, Validators.required],
      // feeAmount: [this.tournamentFetchedDetails.feeAmount, Validators.required],
      // type: [this.tournamentFetchedDetails.type, Validators.required],
      nameEn: [this.tournamentFetchedDetails.nameEn, Validators.required],
      nameAr: [this.tournamentFetchedDetails.nameAr, Validators.required],
      descriptionEn: [this.tournamentFetchedDetails.descriptionEn, Validators.required],
      descriptionAr: [this.tournamentFetchedDetails.descriptionAr, Validators.required],
      tournamentDescEn: [this.tournamentFetchedDetails.tournamentDescEn, Validators.required],
      tournamentDescAr: [this.tournamentFetchedDetails.tournamentDescAr, Validators.required],
      tournamentTypeEn: [this.tournamentFetchedDetails.tournamentTypeEn, Validators.required],
      tournamentTypeAr: [this.tournamentFetchedDetails.tournamentTypeAr, Validators.required],
      tournamentType: [this.tournamentFetchedDetails.tournamentType, Validators.required],
      level: [this.tournamentFetchedDetails.level, Validators.required],
      gender: [this.tournamentFetchedDetails.gender, Validators.required],
      registrationStartDate: [new Date(this.tournamentFetchedDetails.registrationStartDate), Validators.required],
      registrationEndDate: [new Date(this.tournamentFetchedDetails.registrationEndDate), Validators.required],
      fromDate: [new Date(this.tournamentFetchedDetails.fromDate), Validators.required],
      toDate: [new Date(this.tournamentFetchedDetails.toDate), Validators.required],
      noOfGroups: [this.tournamentFetchedDetails.noOfGroups, [Validators.required, Validators.pattern(/^\d+$/)]],
      noOfTeamsPerGroup: [
        this.tournamentFetchedDetails.noOfTeamsPerGroup,
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      noOfRounds: [this.tournamentFetchedDetails.noOfRounds, [Validators.required, Validators.pattern(/^\d+$/)]],
      noOfQualifiedTeams: [
        this.tournamentFetchedDetails.noOfQualifiedTeams,
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      noOfDisqualifiedTeams: [
        this.tournamentFetchedDetails.noOfDisqualifiedTeams,
        [Validators.required, Validators.pattern(/^\d+$/)],
      ],
      noOfTeams: [this.tournamentFetchedDetails.noOfTeams, [Validators.required, Validators.pattern(/^\d+$/)]],
      // noOfTeamsJoined: [
      //   this.tournamentFetchedDetails.noOfTeamsJoined,
      //   [Validators.required, Validators.pattern(/^\d+$/)],
      // ],
      tournamentLogo: [this.tournamentFetchedDetails.tournamentLogo, Validators.required],
      // tournamentOpenFlag: [false],

      tournamentOpenFlag: [this.tournamentFetchedDetails.tournamentOpenFlag, Validators.required],
      registrationOpenFlag: [this.tournamentFetchedDetails.registrationOpenFlag, Validators.required],
      standingsTabFlag: [this.tournamentFetchedDetails.standingsTabFlag, Validators.required],
      matchesTabFlag: [this.tournamentFetchedDetails.matchesTabFlag, Validators.required],

    });
  }

  onSwitchChange(event: any): void {

    const isChecked = event.target.checked; // Adjust according to how the event provides the value
    this.tournamentFormGeneral.get(event.target.name).setValue(isChecked);
  }

  onSubmit(): void {
    if (this.tournamentFormGeneral.valid) {
      // Process the form data
      console.log(this.tournamentFormGeneral.value);
      // if (!this.s3UploadedImage) {
      //   this.toastr.error('Upload Tournament Logo Image First');
      //   return;
      // }

      this.saveTournamentData();
    } else {
      // Form is invalid, show error messages
      this.markFormGroupTouched(this.tournamentFormGeneral);
    }
  }

  saveTournamentData = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .updateTournament(this.tournamentFormGeneral.value, this.tournamentFetchedDetails.id)
        .then(async (res) => {
          this.toastr.success('Tournament saved successfully');
          // this.router.navigate([`tournaments`]);

          this.isLoading = false;

          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error(err.description, 'Error');
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  };

  getSignedURLForImage = (file: File) => {
    const fileExtArray = file.type.split('/');
    let fileExt = fileExtArray[fileExtArray.length - 1];

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv
        .getSignedURL(fileExt, file.type)
        .then(async (res) => {
          this.imageSignedURL = res.data.content;
          await this.uploadFileToS3(res.data.content, file);
          this.isLoading = false;

          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          // this.toastr.error(err.description, "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  };

  uploadFileToS3 = (uploadURL, file) => {
    return new Promise<any>(async (resolve, reject) => {
      this.localInterfaceSrv
        .uploadImageFileToS3(uploadURL, file)
        .then(async (res) => {
          this.toastr.success('IMAGE uploaded');
          let url = new URL(uploadURL);
          url.search = '';
          console.log('Image URL', url.href);
          this.s3UploadedImage = url.href;
          this.tournamentFormGeneral.patchValue({
            tournamentLogo: url.href, // Update the tournamentLogo form control with the image URL
          });
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.log(err);
          this.toastr.error('Error Upload Error');
        });
    });
  };

  markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  positiveNumberValidator(control) {
    const value = control.value;
    if (value !== null && value !== undefined && value <= 0) {
      return { positiveNumber: true };
    }
    return null;
  }
}
